import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'diana-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent {
  @Input()
  textLabel?: string;
  
  @Input()
  id?: string;

  @Input()
  iconName?: string;

  @Input()
  hasBorder = false;

  @Input()
  disabled = false;
  @Input() 
  activatePreventDoubleClick = false;

  @Output()
  btnClick = new EventEmitter<void>();

  doAction() {
    if (!this.disabled) {
      this.btnClick.emit();
    }
  }
}
